export const updateHeaders = (API_ENDPOINT, X_HOST_HEADER) => {
  const clonedApiEndpoint = JSON.parse(JSON.stringify(API_ENDPOINT));

  for (const key in clonedApiEndpoint) {
    if (clonedApiEndpoint[key].headers) {
      if (typeof clonedApiEndpoint[key].headers === 'string' && X_HOST_HEADER[clonedApiEndpoint[key].headers]) {
        clonedApiEndpoint[key].headers = {
          ...X_HOST_HEADER[clonedApiEndpoint[key].headers],
          'x-tenant-id': '*:*:*:*'
        };
      }
    } else if (['setting'].includes(key)) {
      const subEndpoint = clonedApiEndpoint[key];
      for (const subKey in subEndpoint) {
        if (subEndpoint[subKey].headers) {
          if (typeof subEndpoint[subKey].headers === 'string' && X_HOST_HEADER[subEndpoint[subKey].headers]) {
            subEndpoint[subKey].headers = {
              ...X_HOST_HEADER[subEndpoint[subKey].headers],
              'x-tenant-id': '*:*:*:*'
            };
          }
        }
      }
    }
  }

  return clonedApiEndpoint;
};
